const r = (r2) => Array.isArray(r2);
export {
  r as isStringArray
};
//# sourceMappingURL=isStringArray.js.map
